import ExternalEventDetail from "externalEvent/Detail/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const externalEventRoute: RouteObject = {
  path: "externalevent",
  children: [{
    path: ":key",
    loader: () => viewModel,
    Component: ExternalEventDetail,
  }]
};